// Centralized service URL configuration.
// All deployment-specific base URLs live here and are read from the
// environment (.env). To change where this app points in another
// environment, edit the REACT_APP_* values in .env — no code changes needed.
//
// NOTE: Create React App only exposes vars prefixed with REACT_APP_.

// Backend API server (Express). Includes the /api suffix.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
